const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api/v1',
  APP_NAME: process.env.REACT_APP_APP_NAME || 'UNIKOL',
};

export const resolveUploadUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = config.API_URL.replace('/api/v1', '');
  return `${base}${path}`;
};

export default config;
